export default {
  common: {
    brand: "hoobuy.christmas",
    siteName: "HoobuySpreadsheet",
    home: "Início",
    categories: "Categorias",
    buyItNow: "Comprar Agora",
    hoobuySheet: "Hoobuy Sheet",
    accessMainSite: "Acessar HoobuySpreadsheet Completo",
    viewProducts: "Ver Produtos em Alta",
    allCategories: "Todas as Categorias",
    readGuide: "Blog",
    shoppingGuide: "Guia de Compras",
    backToHome: "Voltar ao Início",
  },
  hero: {
    h1Line1: "HoobuySpreadsheet 2026",
    h1Line2: "O Guia Mais Completo de Compras da China",
    subtitle: "Descubra o melhor hoobuyspreadsheet atualizado com produtos virais, preços baixos e fornecedores confiáveis. A sua porta de entrada para compras inteligentes diretamente da China.",
    ctaGuide: "Acessar o Guia Completo",
    ctaProducts: "Ver Produtos Populares",
  },
  categories: {
    title: "Encontre tudo no",
    titleHighlight: "Hoobuy Sheet",
    subtitle: "Navegue pelas nossas categorias e descubra milhares de produtos selecionados.",
    viewProducts: "Ver produtos",
  },
  about: {
    label: "SOBRE O HOOBUY SHEET",
    heading: "Porquê usar o HoobuySpreadsheet?",
    para1: "O hoobuyspreadsheet é uma lista organizada de produtos chineses selecionados manualmente, utilizada por milhares de compradores internacionais para encontrar os melhores negócios. Cada produto é verificado quanto à qualidade, preço e fiabilidade do fornecedor antes de ser adicionado à nossa base de dados.",
    para2: "Ao contrário das compras tradicionais, onde passa horas a pesquisar em dezenas de sites, o nosso hoobuyspreadsheet reúne tudo num só lugar. Comparação de preços, avaliações de fornecedores e produtos em tendência — tudo atualizado diariamente para garantir que tem acesso às melhores oportunidades.",
    para3: "Seja para comprar sneakers de edição limitada, roupa viral do TikTok ou acessórios de designers a preços incríveis, o hoobuyspreadsheet é a ferramenta essencial para qualquer comprador inteligente. Consulte também o nosso guia completo para maximizar as suas poupanças e aprender a identificar os melhores fornecedores chineses.",
    faq1Q: "O que é o hoobuyspreadsheet?",
    faq1A: "É uma lista organizada e verificada de produtos da China, com preços baixos e fornecedores de confiança, usada por compradores em todo o mundo.",
    faq2Q: "É seguro usar o Hoobuy Spreadsheet?",
    faq2A: "Sim. Todos os fornecedores na nossa lista são verificados manualmente. Recomendamos sempre que verifique as avaliações e utilize métodos de pagamento seguros.",
  },
  stats: {
    categories: "Categorias Ativas",
    savings: "Economia Média",
    verified: "Produtos Verificados",
    update: "Atualização Diária",
  },
  products: {
    heading: "Destaques da Planilha",
    subtitle: "Produtos mais procurados em 2026",
    viewOnSheet: "Ver na Planilha",
    redirectNote: "Redirecionamento para kaspreadsheet.com",
  },
  testimonial: {
    label: "AVALIAÇÃO VERIFICADA",
    heading: "Milhares confiam no",
    headingHighlight: "Hoobuy Sheet",
    quote: "Descobri o hoobuyspreadsheet há um ano e mudou completamente a forma como faço compras online. Já poupei mais de 60% em roupa de marca e sneakers. A organização por categorias torna tudo super fácil de encontrar.",
    author: "Lucas M., comprador desde 2024",
  },
  cta: {
    line1: "Economize tempo e dinheiro.",
    line2: "Acesse o hoobuyspreadsheet.",
    line3: "Compre com segurança.",
    button: "ACESSAR HOOBUY SHEET",
    secure: "Link externo seguro",
  },
  articles: {
    readMore: "Ler artigo completo",
    viewAll: "Ver todos os artigos",
  },
  footer: {
    tagline1: "O guia definitivo",
    tagline2: "para compras inteligentes na China",
    navigation: "NAVEGAÇÃO",
    home: "Início",
    categoriesLink: "Categorias",
    blog: "Blog",
    support: "SUPORTE",
    safety: "Segurança",
    faq: "FAQ",
    terms: "Termos",
    social: "REDES",
    copyright: "© 2026 hoobuy.christmas",
    privacy: "Política de Privacidade",
    emailPlaceholder: "O seu e-mail",
  },
};